import { render, staticRenderFns } from "./matchbox.vue?vue&type=template&id=3232913e&scoped=true&"
import script from "./matchbox.vue?vue&type=script&lang=js&"
export * from "./matchbox.vue?vue&type=script&lang=js&"
import style0 from "./matchbox.vue?vue&type=style&index=0&id=3232913e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3232913e",
  null
  
)

export default component.exports